export default {
  disinfectBox: {
    width: "xxl",
    okText: "加入消杀",
    component: () =>
      import("@/mods/warehouse/archivesDisinfect/dialog/ArchivesBoxDialog"),
  },
};
